import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useSearchParams, useOutletContext } from 'react-router-dom';
import PDLManager from '../../components/pdl/PDLManager';

const PDLDashboardPage = () => {
  const [searchParams] = useSearchParams();
  const targetAccountId = searchParams.get('account_id'); 
  const { userProfile, session } = useOutletContext();

  const [allPdls, setAllPdls] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    if (!session?.access_token || !userProfile) return;

    setLoading(true);
    try {
      const isAdmin = userProfile.rang === 0;
      
      if (isAdmin) {
        // Admin : chargement de tous les PDL
        const pdlResponse = await fetch('/api/pdl/admin/all', {
          headers: { 'Authorization': `Bearer ${session.access_token}` }
        });

        const pdlResult = await pdlResponse.json();
        
        if (pdlResult.success) {
          setAllPdls(pdlResult.data);
        } else {
          throw new Error(pdlResult.message || "Erreur de chargement des PDL");
        }

      } else {
        // Non-admin : chargement des PDL de l'utilisateur
        const pdlResponse = await fetch('/api/pdl/', {
          headers: { 'Authorization': `Bearer ${session.access_token}` }
        });
        
        const pdlResult = await pdlResponse.json();
        
        if (pdlResult.success) {
          setAllPdls(pdlResult.data); 
        } else {
          throw new Error(pdlResult.message || "Erreur de chargement des PDL");
        }
      }
    } catch (error) {
      console.error("Erreur lors du chargement des données PDL:", error);
      setAllPdls([]);
    } finally {
      setLoading(false);
    }
  }, [session?.access_token, userProfile]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  
  const filteredPdls = useMemo(() => {
    const isTargetingAccount = !!targetAccountId;
    const isAdmin = userProfile?.rang === 0;

    if (isAdmin && isTargetingAccount) {
      return allPdls.filter(pdl => pdl.account_id === targetAccountId);
    }
    return allPdls;
  }, [targetAccountId, allPdls, userProfile?.rang]);

  return (
    <div className="space-y-3 p-3">
      {/* Titre optionnel - peut être supprimé si PDLManager a déjà un titre */}
      {targetAccountId && (
        <div className="bg-white rounded shadow border p-3">
          <h1 className="text-base font-bold text-gray-900">
            Points de Livraison Électricité du Client
          </h1>
          <p className="mt-0.5 text-xs text-gray-600">
            Détail des PDL pour ce client.
          </p>
        </div>
      )}

      {loading ? (
        <div className="text-center p-6 bg-white rounded shadow border">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-2"></div>
          <p className="text-xs text-gray-600">Chargement des PDL...</p>
        </div>
      ) : (
        <PDLManager
          pdls={filteredPdls} 
          onRefresh={fetchData}
        />
      )}
    </div>
  );
};

export default PDLDashboardPage;
